import { useEffect } from "react";
import { setActiveCommunityGroup } from "@/src/common/lib/posthog";
import { getSubdomain } from "@/src/common/lib/subdomain";
import { useAppDispatch, useAppSelector } from "@/src/common/redux/store";
import { setVariant } from "@/src/common/store/general-slice";
import { useGetCommunityBySlugQuery } from "@/src/community/services/community-http.service";
import { setActiveCommunityId, setActiveMemberRole } from "@/src/community/store/community-slice";
import { useGetMyMembershipQuery } from "@/src/member/services/member-http.service";
import { getActiveCommunityId } from "../store/community-selectors";

export function useActiveCommunity() {
	const dispatch = useAppDispatch();
	const subdomain = getSubdomain();
	const storedCommunityId = useAppSelector(getActiveCommunityId);

	const { data: communityData } = useGetCommunityBySlugQuery(subdomain ?? "", { skip: !subdomain });
	const communityId = communityData?.community?.id;
	const communityVariant = communityData?.community?.variant;

	const { data: memberData } = useGetMyMembershipQuery(communityId ?? "", { skip: !communityId });

	useEffect(() => {
		if (communityId && communityId !== storedCommunityId) {
			dispatch(setActiveCommunityId(communityId));
			setActiveCommunityGroup(communityId);
		}
	}, [communityId, storedCommunityId, dispatch]);

	useEffect(() => {
		if (memberData?.member?.role) {
			dispatch(setActiveMemberRole(memberData.member.role));
		}
	}, [memberData, dispatch]);

	useEffect(() => {
		if (communityVariant) {
			dispatch(setVariant(communityVariant));
		}
	}, [communityVariant, dispatch]);
}
